import request from '@/utils/request'

// 保存分类
export function reqMemberList(data) {
  return request({
    url: '/admin/member/list',
    method: 'post',
    params: data
  })
}

// // 用户简历
// export function reqMemberResume(data) {
//   return request({
//     url: '/admin/member/list',
//     method: 'post',
//     params: data
//   })
// }

// 用户反馈列表
export function reqFeedbackList(data) {
  return request({
    url: '/admin/memberFeedback/list',
    method: 'post',
    params: data
  })
}

// 用户反馈列表用户名
export function reqMemberByIds(data) {
  return request({
    url: '/admin/member/ids',
    method: 'post',
    params: data
  })
}

// 查看用户简历
export function reqMemberResume(data) {
  return request({
    url: '/admin/member/resume',
    method: 'post',
    params: data
  })
}

// 用户账号更新
export function reqUpdateMemberStatus(data) {
  return request({
    url: '/admin/member/updateStatus',
    method: 'post',
    data
  })
}

// 用户反馈列表
export function reqResumeList(data) {
  return request({
    url: '/admin/memberSendResumeRecord/list',
    method: 'post',
    params: data
  })
}
